var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({class:_setup.buttonClasses,attrs:{"type":"button","aria-label":_vm.isUpvote ? 'Up vote' : 'Down vote'}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }